import { VFC } from 'react'
import 'slick-carousel/slick/slick.css'
import { logPromotionClick } from 'src/api/promotion'
import { postInterested, postNotInterested } from 'src/api/recommendation'
import { TipsLink } from 'src/components/Link'
import { RecommendationCardBase } from 'src/components/UserCard'
import { RecommendedUser } from 'src/models/User'
import { GUIDE_LINK } from 'src/utils/routes'
import styled from 'styled-components'
import { UserCardFC, UserCards } from './UserCards'

type RecommendationsProps = {
  recommendedUsers: RecommendedUser[]
  showTips?: boolean
}
export const Recommendations: VFC<RecommendationsProps> = ({
  recommendedUsers,
  showTips,
}) => (
  <UserCards
    title="今日のAIピック"
    description={<RecommendationDescription showTips={showTips} />}
    users={recommendedUsers}
    CardComponent={RecommendationCard}
  />
)

const TipsLinkWrap = styled.div`
  margin-bottom: 34px;
`

type RecommendationDescriptionProps = {
  showTips?: boolean
}
const RecommendationDescription: VFC<RecommendationDescriptionProps> = ({
  showTips,
}) => {
  return (
    <>
      {showTips && (
        <TipsLinkWrap>
          <TipsLink to={GUIDE_LINK} color="blue" />
        </TipsLinkWrap>
      )}
      <p>{`AIが厳選！毎朝5時にあなたに最適な決裁者をおすすめします。
「つながり申請」を送信し、相手が「承認」すればつながりが成立。メッセージのやり取りが可能になります。
※「つながり申請」はメッセージの件数を消費しません。
※「興味なし」を選択しても相手には通知されません。`}</p>
    </>
  )
}

const RecommendationCard: UserCardFC<RecommendedUser> = ({
  user,
  showDetail,
  showReasonModal,
  closeReasonModal,
  showPrDetailModal,
  openSalesDemoModal,
  salesDemoPlan,
}) => (
  <RecommendationCardBase
    user={user}
    showDetail={() => {
      showDetail(user.id)
      if (user.promotion)
        logPromotionClick({ userId: user.id, ...user.promotion })
    }}
    showReasonModal={() => {
      showReasonModal((reason, detail) =>
        postInterested(user.id, reason, user.promotion, detail).then(() =>
          closeReasonModal(),
        ),
      )
    }}
    postNotInterested={() =>
      salesDemoPlan
        ? openSalesDemoModal()
        : postNotInterested(user.id, user.promotion)
    }
    showPrDetailModal={showPrDetailModal}
  />
)
